import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import UrzadService from "../UrzadService";
import UrzadRaportDopatSumSearchbox from "./components/UrzadRaportDopatSumSearchbox";
import UrzadRaportDoplatSumTable from "./components/UrzadRaportDoplatSumTable";

export default class UrzadRaportDoplatSuma extends Component {
    constructor(props) {
        super(props);
        this.state = {
            raporty: [],
            czyByloSzukanie: false,
            setLoader: false,
            dataOd:'',
            dataDo:''
        };
    }

    componentDidMount() {
    }



    onClickSzukaj(dataOd, dataDo) {
        this.setState({czyByloSzukanie: true, setLoader: true})
        UrzadService.getpUrzadDoplatyDoGrupSuma(dataOd, dataDo).then(function (response) {
            console.log(response)

            this.setState({
                raporty: response.data,
                setLoader: false,
                dataOd:dataOd,
                dataDo:dataDo
            })

        }.bind(this))
    }


    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'UrzadContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb
                                    links={[{addressUrl: '/urzad', text: 'Urząd'}, {
                                        addressUrl: '/urzad/raport-doplat-suma',
                                        text: 'Raport dopłat suma'
                                    }]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <UrzadRaportDopatSumSearchbox handleClickSzukaj={(dataOd, dataDo) => this.onClickSzukaj(dataOd, dataDo)}/>
                        </Col>
                        <Col sm={12}>
                            {
                                Boolean(this.state.czyByloSzukanie) ?
                                    Boolean(this.state.setLoader) ?
                                        <div id={'simple-small-loader'}>
                                            <i className={'fa fa-spinner fa-spin'}></i>
                                        </div>
                                        :
                                        <div>
                                            <UrzadRaportDoplatSumTable data={this.state.raporty} dataOd={this.state.dataOd} dataDo={this.state.dataDo}/>
                                        </div>
                                    :
                                    ''
                            }
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/raportDopatSuma/UrzadRaportDoplatSuma.js